module.exports = __webpack_public_path__ + "img/shopping-bag.e4cbc1e6.svg";